import React from 'react'
import { useAppContext } from '../../context/siteMapContext'

interface IArticleTitle {
  title: string
}

const ArticleTitle: React.FC<IArticleTitle> = ({ title }) => {
  const { highContrastOn } = useAppContext();
  return (
    <h3 className={`text-article-title font-montserrat font-semibold ${highContrastOn ? 'text-white' : 'text-black'}`}>
      {title}
    </h3>
  )
}

export default ArticleTitle
